import React from 'react';
import Header from './Header';
import ErrorPage from '../pages/ErrorPage';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Unhandled application error:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="app-container">
          <Header />
          <main className="main-content">
            <ErrorPage type="500" onRetry={this.handleRetry} embedded />
          </main>
        </div>
      );
    }

    return this.props.children;
  }
}
